import dotProp from 'dot-prop-immutable';
import type { Action } from '../typings/reducers';

type Watermark = { _id: string } & Record<string, unknown>;
type WatermarksState = Record<string, Watermark>;

export default function (state: WatermarksState = {}, action: Action): WatermarksState {
  switch (action.type) {
    case 'UPDATE_WATERMARK_VALUE':
      const watermark = state[action.payload.watermark_id];

      if (watermark) {
        const updatedWatermark = dotProp.set(watermark, action.payload.key, action.payload.value);

        return { ...state, [action.payload.watermark_id]: updatedWatermark };
      }

      return state;

    case 'SET_WATERMARKS':
      const watermarks: Record<string, Watermark> = {};
      (action.payload as Watermark[]).forEach((wm) => (watermarks[wm._id] = wm));

      return { ...state, ...watermarks };

    case 'ADD_WATERMARK':
      return { ...state, [action.payload._id]: action.payload };

    case 'REMOVE_WATERMARK':
      return { ...state, [action.payload]: undefined } as unknown as WatermarksState;

    case 'RESET_WATERMARKS_DATA':
      return state;

    default:
      return state;
  }
}
